<template>

  <el-row :gutter="20" class="top-block">

    <Breadcrumb :route="this.$route"></Breadcrumb>

    <!-------------------------------------------------------------------->
    <!-- action -->
    <!-------------------------------------------------------------------->


    <!-------------------------------------------------------------------->
    <!-- table -->
    <!-------------------------------------------------------------------->
    <el-col :xs="24" :sm="24" :lg="24">

      <el-col :xs="24" :sm="24" :lg="5">
        <el-main>
          <el-table :data="groupByTableData"
                    default-expand-all
                    row-key="id"
                    empty-text="無資料"
                    stripe header-row-class-name="headerStyle">
            <el-table-column label="流程名稱">
              <template slot-scope="scope">
                <el-button type="text" @click.prevent="searchTerm(scope.row.col)"> {{scope.row.col}} ({{scope.row.count}})</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-main>
      </el-col>

      <el-col :xs="24" :sm="24" :lg="19">
        <el-main>
          <el-table :data="tableData"
                    default-expand-all
                    row-key="id"
                    empty-text="無資料"
                    stripe header-row-class-name="headerStyle">
            <el-table-column prop="flowName" label="流程名稱" width="200">
            </el-table-column>

            <el-table-column prop="step1User" label="第一層簽核" width="120">
              <template slot-scope="scope">
                  <span v-for="(s,idx) in scope.row.step1User" :key="idx">
                    <el-tag type="success" class="mr-10 mt-10">{{s.username}}</el-tag>
                  </span>
              </template>
            </el-table-column>

            <el-table-column prop="step2User" label="第二層簽核" width="120">
              <template slot-scope="scope">
                  <span v-for="(s,idx) in scope.row.step2User" :key="idx">
                    <el-tag class="mr-10 mt-10">{{s.username}}</el-tag>
                  </span>
              </template>
            </el-table-column>

            <el-table-column prop="step3User" label="第三層簽核" width="120">
              <template slot-scope="scope">
                  <span v-for="(s,idx) in scope.row.step3User" :key="idx">
                    <el-tag type="success" class="mr-10 mt-10">{{s.username}}</el-tag>
                  </span>
              </template>
            </el-table-column>
            

            <el-table-column prop="stepNotifyUser" label="結案額外通知人">
              <template slot-scope="scope">
                  <span v-for="(s,idx) in scope.row.stepNotifyUser" :key="idx">
                    <el-tag class="mr-10 mt-10">{{s.username}}</el-tag>
                  </span>
              </template>
            </el-table-column>

            <el-table-column prop="vpThreshold" label="最末層送簽門檻">
              <template slot-scope="scope">
                <span v-if="scope.row.vpThreshold>0">$</span>{{scope.row.vpThreshold}}
                  <el-button type="primary" v-if="scope.row.vpThreshold != null" @click="handleEditThreshold(scope.row)" circle><i class="el-icon-edit"></i></el-button>
              </template>
            </el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="warning" @click="handleEdit(scope.row)" >編輯 <i class="el-icon-edit"></i></el-button>
              </template>
            </el-table-column>
          </el-table>

          <div style="border-radius:8px; margin-top:10px;padding:20px 10px; text-align: center; background-color: white">
            <el-pagination
                background
                layout="prev, pager, next"
                :current-page="pageNum"
                :page-size="pageSize"
                :total="total"
                @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </el-main>
    </el-col>
    </el-col>

    <!-------------------------------------------------------------------->
    <!-- dialog -->
    <!-------------------------------------------------------------------->
    <el-dialog title="簽核資訊"
               :visible.sync="dialogFormVisible"
               :width="dw"
               @close="closeDialog">

      <el-form :model="form"
               :rules="rules"
               ref="dataForm"
               label-width="120px">
        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="名稱" prop="name">
              <el-input :disabled="true" v-model="form.flowName" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item prop="step1UserOption" label="第一層簽核" :label-width="formLabelWidth">
              <el-select
                  v-model="form.step1UserOption"
                  :clearable="true"
                  multiple
                  @remove-tag="removeTag"
                  placeholder="選擇第一層簽核" style="width: 100%">
                <el-option
                    v-for="item in mgrOptions"
                    :key="item.id"
                    :label="item.username"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="第二層簽核" :label-width="formLabelWidth">
              <el-select
                  v-model="form.step2UserOption"
                  multiple
                  :clearable="true"
                  placeholder="選擇第二層簽核" style="width: 100%">
                <el-option
                    v-for="item in mgrOptions"
                    :key="item.id"
                    :label="item.username"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="第三層簽核" :label-width="formLabelWidth">
              <el-select
                  v-model="form.step3UserOption"
                  multiple
                  :clearable="true"
                  placeholder="選擇第三層簽核" style="width: 100%">
                <el-option
                    v-for="item in mgrOptions"
                    :key="item.id"
                    :label="item.username"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="結案額外通知人" :label-width="formLabelWidth">
              <el-select
                  v-model="form.stepNotifyUserOption"
                  multiple
                  :clearable="true"
                  placeholder="結案額外通知人" style="width: 100%">
                <el-option
                    v-for="item in mgrOptions"
                    :key="item.id"
                    :label="item.username"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>



        <!--          <el-form-item label="第二層簽核" >-->
        <!--            <el-checkbox-group >-->
        <!--              <el-checkbox v-for="p in mgrOptions" :key="p.id" :label="p.username"></el-checkbox>-->
        <!--            </el-checkbox-group>-->
        <!--          </el-form-item>-->
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveData('dataForm')">確 定</el-button>
      </div>
    </el-dialog>


    <el-dialog title="簽核金額門檻設定"
               :visible.sync="signLimitDialog"
               :width="dw">

      <el-form class="myform" label-position="top"
                :model="signLimitForm"
               :rules="rules"
               ref="signLimitForm">
        <el-form-item label="金額" prop="vpThreshold">
          <el-input v-model="signLimitForm.vpThreshold" autocomplete="off"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="signLimitDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveSignLimit('signLimitForm')">確 定</el-button>
      </div>
    </el-dialog>
  </el-row>

</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";

export default {
  name: "SignoffMaintain",
  components: {
    Breadcrumb
  },
  data() {
    let checkLength = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('請至少選擇一位人員'))
      } else {
        callback()
      }
    }
    return {
      signLimitForm:{
        id: '',
        vpThreshold: 0
      },
      signLimitDialog: false,
      groupByTableData:[],
      checkList: [],
      options: [],
      mgrOptions: [],
      dw: '50%',
      tableData: [],
      queryField: '',
      keyword: '',
      pageNum: 1,
      pageSize: 15,
      total: 0,
      dialogFormVisible: false,
      formLabelWidth: '',
      selectedUser: '',
      form: {
        name: '',
        value: '',
        type: '',
        step1User: '',
        step1UserOption: [],
        step1UserOptionDisplay: [],
        step2User: '',
        step2UserOption: [],
        step2UserOptionDisplay: [],
        step3User: '',
        step3UserOption: [],
        step3UserOptionDisplay: [],
        stepNotifyUser: '',
        stepNotifyUserOption: [],
        stepNotifyUserOptionDisplay: []
      },
      rules: {
        // step1UserOption: [{validator: checkLength, trigger: 'select'}]
      }
    }
  },
  methods: {
    searchTerm(term){
      this.keyword = term
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.loadData()
    },
    loadFlow() {
      this.request.get("/dic/type?queryField=job_type").then(res => {
        if (res.code === '200') {
          this.options = res.data
        }
      })
    },
    loadSigner() {
      this.request.get("/user/mgr").then(res => {
        if (res.code === '200') {
          this.mgrOptions = res.data
        }
      })
    },
    saveSignLimit(){
      let { id, vpThreshold } = this.signLimitForm
      let url = "/signoff/limit?id=" + id + "&vpThreshold=" + vpThreshold
      this.request.post(url).then(res => {
          if (res.code === '200') {
            this.signLimitDialog =false
            this.loadData()
            this.showResult('success', '設定成功')
          } else {
            this.showResult('error', '設定失敗')
          }
      })
    },
   loadData() {
      let { pageNum, pageSize, keyword } = this

      let url = "/signoff/page?pageNum=" + pageNum + "&pageSize=" + pageSize + "&keyword=" + keyword

      this.request.get(url).then(res => {
          this.tableData = res.data.records
          this.total = res.data.total
      })

      // let result = await this.$store.dispatch('signoff/getAllSignoffs', data);
      // this.tableData = result.data.records
      // this.total = result.data.total
    },

    async saveData(formName) {

      this.$refs[formName].validate(async valid => {
        if (valid) {
          try {
            // if (this.form.step1UserOption !== null) {
            //   this.form.step1User = this.form.step1UserOption.join(',')
            // }
            // if (this.form.step2UserOption !== null) {
            //   this.form.step2User = this.form.step2UserOption.join(',')
            // }

            console.log(this.form)

            await this.$store.dispatch('signoff/saveSignoff', this.form)

            this.showResult('success', '資料更新成功')

            await this.loadData()
            this.dialogFormVisible = false

          } catch (e) {
            this.showResult('error', '資料更新失敗')
          }
        }
      })
    },
    handleAdd() {
      this.dialogFormVisible = true
      this.form = {}
    },
    handleEdit(row) {
      this.dialogFormVisible = true
      this.form = row


      this.form.step1UserOption = row.step1User.map(({userId})=> userId)
      this.form.step2UserOption = row.step2User.map(({userId})=> userId)
      this.form.step3UserOption = row.step3User.map(({userId})=> userId)
      this.form.stepNotifyUserOption = row.stepNotifyUser.map(({userId})=> userId)

      // console.log('after:', this.form.step1UserOption)
      // this.form.step1UserOptionDisplay = this.form.step1UserOption
    },
    handleEditThreshold(row){
      this.signLimitForm.id = row.id 
      this.signLimitForm.vpThreshold = row.vpThreshold 
      this.signLimitDialog = true

    },
    closeDialog() {
      this.loadData()
      this.$refs['dataForm'].resetFields();
    },
    addUser() {
      this.step1User.push(this.selectedUser);
      this.selectedUser = '';
    },
    handleClose() {

    },
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = "400"; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%"
      } else {
        this.dw = "50%"
      }
    },
    removeTag(t) {
      console.log('click:', t)
      console.log('current', this.form.step1UserOption)

      this.$nextTick(() => {
        this.form.step1UserOption = this.form.step1UserOption
      })

    },
    loadGroupbyData() {
      this.request.get("/signoff/groupby").then(res => {
        if (res.code === '200') {
          this.groupByTableData = res.data
        }
      })
    }

  },
  filters: {
    transformType(value) {
      console.log('value:', value)
      let label = ''
      switch (value) {
        case 'menu_icon':
          label = "選單圖示"
          break;
        case 'apply_pay':
          label = "請款類型"
          break;
        case 'apply_buy':
          label = "請購類型"
          break;
        case 'job_type':
          label = "簽核工作類型"
          break;
        default:
          label = "未知?"
      }
      return label
    }
  },
  mounted() {
    this.loadData()
    //this.loadFlow()
    this.loadSigner()
    this.loadGroupbyData()
    this.setDialogWidth();
  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.el-table >>> .headerStyle {
  /*background-color: #1e8fc6;*/
}

.el-popover.el-popper .el-popconfirm {
  background-color: black !important;
  padding: 10px !important;
}

.el-main {
  padding: 20px 4px;
}

</style>
